import React from 'react';
import { Box, Container, Typography, Button, Stack } from '@mui/material';
import { motion } from 'framer-motion';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link as RouterLink } from 'react-router-dom';

const fade = (delay: number) => ({
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.7, delay, ease: 'easeOut' as const },
});

const HeroSection: React.FC = () => {
  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Box
      id="hero"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        bgcolor: '#0c0c0c',
      }}
    >
      <Container maxWidth="md" sx={{ textAlign: 'center', py: 16 }}>
        <motion.div {...fade(0.1)}>
          <Typography
            variant="overline"
            sx={{
              color: 'text.secondary',
              fontWeight: 600,
              letterSpacing: 4,
              fontSize: '0.75rem',
              mb: 4,
              display: 'block',
            }}
          >
            INTRODUCING TOSTRUCTURE
          </Typography>
        </motion.div>

        <motion.div {...fade(0.25)}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '2.8rem', sm: '3.8rem', md: '5rem' },
              fontWeight: 800,
              lineHeight: 1.05,
              mb: 3,
              color: '#ffffff',
            }}
          >
            Talk to Your{' '}
            <Box
              component="span"
              sx={{ color: 'primary.main' }}
            >
              Data.
            </Box>
          </Typography>
        </motion.div>

        <motion.div {...fade(0.4)}>
          <Typography
            variant="body1"
            sx={{
              maxWidth: 560,
              mx: 'auto',
              mb: 6,
              color: 'text.secondary',
              fontSize: { xs: '1rem', md: '1.15rem' },
              lineHeight: 1.8,
            }}
          >
            A native desktop AI app for Mac and Windows that connects to your databases,
            generates visualizations, and delivers citation-ready insights through
            natural conversation. Run it entirely local — your data never leaves your machine.
          </Typography>
        </motion.div>

        <motion.div {...fade(0.55)}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
            <Button
              component={RouterLink}
              to="/tostructure"
              variant="contained"
              size="large"
              endIcon={<ArrowForwardIcon />}
              sx={{
                px: 4,
                py: 1.5,
                fontSize: '0.9rem',
                bgcolor: 'primary.main',
                '&:hover': { bgcolor: '#1d4ed8' },
              }}
            >
              Explore ToStructure
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={() => handleScroll('#contact')}
              sx={{
                px: 4,
                py: 1.5,
                fontSize: '0.9rem',
                borderColor: 'rgba(255, 255, 255, 0.2)',
                color: '#ffffff',
                '&:hover': {
                  borderColor: '#ffffff',
                  bgcolor: 'transparent',
                },
              }}
            >
              Get In Touch
            </Button>
          </Stack>
        </motion.div>
      </Container>
    </Box>
  );
};

export default HeroSection;
